import { render, staticRenderFns } from "./dayHighlightsSlider.vue?vue&type=template&id=5b3b1830"
import script from "./dayHighlightsSlider.vue?vue&type=script&lang=js"
export * from "./dayHighlightsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports